import { render, staticRenderFns } from "./PermissionsCheckList.vue?vue&type=template&id=0fc63ab2&scoped=true"
import script from "./PermissionsCheckList.vue?vue&type=script&lang=js"
export * from "./PermissionsCheckList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc63ab2",
  null
  
)

export default component.exports